import { render, staticRenderFns } from "./ModalMedicine.vue?vue&type=template&id=61a17087&scoped=true"
import script from "./ModalMedicine.vue?vue&type=script&lang=js"
export * from "./ModalMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a17087",
  null
  
)

export default component.exports